export const formContentStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  width: '100%',
};
